module.exports = __webpack_public_path__ + "media/images/facebook-i-46cec848fb0de13ac60835140f279749.png";